"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventBus = void 0;
var EventBus = /** @class */ (function () {
    /**
     * @constructor
     * @param {string} prmDescription the name of your EventBus
     */
    function EventBus(prmDescription) {
        if (prmDescription === void 0) { prmDescription = ''; }
        this.bufferEvent = {};
        this.eventTarget = document.appendChild(document.createComment(prmDescription));
    }
    Object.defineProperty(EventBus.prototype, "_eventTarget", {
        get: function () {
            return this.eventTarget;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Add EventListener to specific event from the bus
     * @param {string} prmEventName name of your event
     * @param {CustomEvent} prmListener your CustomEvent that will received the emit event.
     */
    EventBus.prototype.on = function (prmEventName, prmListener) {
        var alreadyEmit = this.testIfEventAlreadyExist(prmEventName);
        if (alreadyEmit) {
            prmListener.call(this, alreadyEmit);
        }
        this.eventTarget.addEventListener(prmEventName, prmListener);
    };
    /**
     * Add EventListener once to specific event from the bus
     * @param {string} prmEventName name of your event
     * @param {CustomEvent} prmListener your CustomEvent that will received the emit event.
     */
    EventBus.prototype.once = function (prmEventName, prmListener) {
        var alreadyEmit = this.testIfEventAlreadyExist(prmEventName);
        if (alreadyEmit) {
            prmListener.call(this, alreadyEmit);
        }
        else {
            this.eventTarget.addEventListener(prmEventName, prmListener, { once: true });
        }
    };
    /**
     * Remove EventListener to specific event from the bus
     * @param {string} prmEventName name of your event
     * @param {CustomEvent} prmListener your CustomEvent that will be removed.
     */
    EventBus.prototype.off = function (prmEventName, prmListener) {
        this.eventTarget.removeEventListener(prmEventName, prmListener);
    };
    /**
     *
     * @param {string} prmEventName name of your event
     * @param {CustomEvent<detail>} prmDetail data for your emitted event.
     * @returns boolean
     */
    EventBus.prototype.emit = function (prmEventName, prmDetail) {
        var event = new CustomEvent(prmEventName, { detail: prmDetail });
        this.bufferEvent[prmEventName] = event;
        return this.eventTarget.dispatchEvent(event);
    };
    EventBus.prototype.testIfEventAlreadyExist = function (prmEventName) {
        if (Object.prototype.hasOwnProperty.call(this.bufferEvent, prmEventName)) {
            return this.bufferEvent[prmEventName];
        }
    };
    return EventBus;
}());
exports.EventBus = EventBus;
//# sourceMappingURL=event-bus.js.map